import { takeEvery, put, take, select, call } from 'redux-saga/effects'
import { push } from 'connected-react-router'
import {
  RESET_PRE_CREATE_NEW_FEATURE,
  CREATE_NEW_FEATURE,
  FEATURE_CREATED,
  FEATURE_CREATE_FAILED,
} from 'actions/feature/features'
import {
  setIsDrawerVisible,
  setShowDrawerMask,
  SET_DRAWER_CLOSED,
} from 'actions/drawer'
import {
  setSelectedId,
  setIsEditing,
  removeComponentMeta,
} from 'actions/navigator'
import { getCurrentFeature } from 'selectors/feature/features'
import { create } from 'services/features'

import { apiAction } from 'actions/application'
import { createModalErrorHandler } from 'sagas/errorHandlers'
import { DEFAULT_ID } from 'constants/featureDefaults'

const createFeatureAction = (feature, onError) =>
  apiAction({
    asyncFn: create,
    args: { feature },
    successActionType: FEATURE_CREATED,
    failureActionType: FEATURE_CREATE_FAILED,
    // When onError is provided the error is shown inline inside the modal via
    // ModalErrorContent rather than via a global overlay.
    errorHandlers: onError ? [createModalErrorHandler(onError)] : [],
  })

export function* watchResetPreCreateNewFeature() {
  yield takeEvery(RESET_PRE_CREATE_NEW_FEATURE, resetPreCreateNewFeature)
}

function* resetPreCreateNewFeature() {
  yield put(setIsDrawerVisible(false))

  yield call(closeFeatureDrawer, () => put(removeComponentMeta([DEFAULT_ID])))
}

function* closeFeatureDrawer(callback) {
  yield take(SET_DRAWER_CLOSED)
  yield put(setShowDrawerMask(false))
  yield put(setIsEditing(false))
  yield put(setSelectedId(null))

  yield callback()
}

export function* watchCreateNewFeature() {
  yield takeEvery(CREATE_NEW_FEATURE, createNewFeature)
}

function* createNewFeature({ onError }) {
  const currentFeature = yield select(getCurrentFeature)
  const newFeature = currentFeature.feature[DEFAULT_ID]

  yield put(createFeatureAction(newFeature, onError))
}

export function* watchCreateSuccess() {
  yield takeEvery(FEATURE_CREATED, createSuccess)
}

function* createSuccess({
  data: {
    feature: { feature },
  },
}) {
  const [id] = Object.keys(feature)
  yield put(
    push({
      pathname: `/features/${id}`,
      search: '?editing=true',
      state: {
        isNewFeature: true,
      },
    })
  )

  yield put(setShowDrawerMask(false))
}
